export default {
    setParts(state, parts) {
        state.parts = parts;
    },
    setActivePart(state, part) {
        state.activePart = part;
    },
    setManagePartDialog(state, status) {
        state.managePartDialog = status;
    },
    setManageDeletePartDialog(state, status) {
        state.manageDeletePartDialog = status;
    }
}
